import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["minWidth", "use", "children"];
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "ToolBarGroup__StyledFlex",
  componentId: "v8lzrp-0"
})(({
  $use,
  $minWidth,
  $cssStyles,
  theme
}) => {
  const calculatedMinWidth = typeof $minWidth === 'number' ? `${$minWidth}px` : $minWidth;
  return Object.assign({
    display: 'flex',
    alignItems: 'center',
    flexBasis: $minWidth ? calculatedMinWidth : '0%',
    flexGrow: 1,
    maxInlineSize: '100%',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    '> * + *': {
      marginInlineStart: theme.space['300']
    },
    // order specific styles
    '&:nth-child(2)': {
      flexShrink: 1,
      flexGrow: 1,
      justifyContent: 'center',
      '&:last-child': {
        flexGrow: 2
      }
    },
    '&:nth-child(3)': {
      '&:last-child': {
        justifyContent: 'flex-end'
      }
    }
  }, $use === 'filter-bar' && {
    flexBasis: 'auto',
    flexGrow: 9999,
    '&:last-child': {
      flexBasis: '400px',
      flexGrow: 1,
      justifyContent: 'flex-end'
    }
  }, $use === 'tabs' && {
    '&:nth-child(2)': {
      flexBasis: 'auto',
      minInlineSize: '50px'
    },
    '&:not(:nth-child(2))': {
      flexGrow: 0,
      flexShrink: 0
    }
  }, $use === 'dark' && {
    '&:nth-child(2)': {
      flexBasis: 'auto'
    }
  }, $cssStyles);
});
export { StyledFlex as StyledToolBarGroup };
export const ToolBarGroup = _ref => {
  let {
      minWidth,
      use = 'default',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledFlex, Object.assign({
    $minWidth: minWidth,
    $cssStyles: cssStyles,
    $use: use
  }, domProps, {
    children: children
  }));
};